export const NAV_ITEMS = [
  "About Us",
  "Sports",
  "Gallery",
  "Pricing",
  "Services",
  "Facilities",
  "Contact Us",
];
